export default __webpack_public_path__ + "static/media/access_denied.e41c2f8a.png";